import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, Observer } from 'rxjs';
import { environment } from '../environments/environment';
import { Subscription } from 'rxjs/Subscription';

@Injectable({
  providedIn: 'root'
})

export class SingleResponse {
  debugData: string;
  fullRecordCount: number;
  item: null;
  list: any;
  rawList: any;
  recordCount: number;
  returnCode: number;
  returnText: string;
}


export class Responses {
  public errors: SingleResponse[] = [];
  public success: SingleResponse[] = [];
}

@Injectable()
export class BaseAPIService {

  apiURL = `${environment.systemAPI}/`;
  genericError = 'Some Error occurred, Please contact Administrator for the Errors';
  httpOptions;

  constructor(private httpClient: HttpClient) {
  }

  get<T>(endPoint: string, params?: HttpParams, apiUrl?: string): Observable<T> {
    const response = this.httpClient.get<Responses & T>(`${apiUrl || this.apiURL}${endPoint}`, {params});
    return this.baseApiResponse(response);
  }

  post<T>(endPoint: string, body: any, params?: HttpParams, apiUrl?: string): Observable<T> {
    const response = this.httpClient.post<Responses>(`${apiUrl || this.apiURL}${endPoint}`, body, {params});
    return this.baseApiResponse(response);
  }

  delete<T>(endPoint: string, params?: HttpParams): Observable<T> {
    const response = this.httpClient.delete<Responses>(`${this.apiURL}${endPoint}`, {params});
    return this.baseApiResponse(response);
  }

  private baseApiResponse(response) {
    return Observable.create((observer: Observer<any>) => {
      const subscription: Subscription = response?.subscribe(res => {
        observer.next(res);
        observer.complete();
      }, error => {
        if (error?.status === 200) { // This case for return status 200
          return observer.complete();
        }
        observer.error([{title: error.name, detail: this.genericError, error}]);
      });
      return () => {
        subscription.unsubscribe();
      };
    });
  }
}
